<template>
  <m-dialog ref="dlgKelasLuring" :isclose="true" :btnsave="false" :fullscreen="true" title="Informasi Kelas">
    <v-card class="rounded-lg elevation-0 pa-5 mt-5">
      <v-row class="lg-mt-5">
        <v-col cols="12" sm="12" class="ml-4">
          <div>
            <p class="grey--text my-0 pb-0">
              Nama Kelas
            </p>
            <p class="primary--text font-weight-bold body-1">{{ pVal(info, "nama") }} {{ pVal(info, "angkatan") }}</p>
            <p class="grey--text my-0 pb-0">
              Jadwal Pelaksanaan
            </p>
            <p>{{ pVal(info, "tanggal_mulai") | toD }} s/d {{ pVal(info, "tanggal_selesai") | toD }}</p>
            <div class="py-4">
              <m-alert type="info" show>
                <template v-slot:default>
                  <span class="black--text">Akses Modul Pembelajaran kelas <strong>{{ pVal(info, "nama") }} {{ pVal(info, "angkatan") }}</strong> tersedia {{isReady?'pada tautan berikut ini':'H-2 sebelum tanggal awal Pelaksanaan Kelas'}}
                    <br v-if="isReady"/><br v-if="isReady"/><m-button class="mt-n1 px-2 mt-2" color="success" v-if="isReady" textButton="Tautan LMS" action="toLink" @toLink="toLink(info)"></m-button> <br/><br/>Jika terjadi kendala terkait Layanan Pembelajaran hubungi Helpdesk melalui tautan berikut <a :href="current_instansi.url_telegram ">BANTUAN</a></span>
                </template>
              </m-alert>
            </div>
          </div>
        </v-col>
      </v-row>
      <v-row v-if="false">
        <v-col cols="12">
          <ListPengelola :kelas="info" />
        </v-col>
      </v-row>
    </v-card>
  </m-dialog>
</template>

<script>
import addDays from "date-fns/add_days";
import subDays  from "date-fns/sub_days";
import ListPengelola from "../components/ListPengelola.vue";
export default {
  components: {
    ListPengelola
  },
  data() {
    return {
      dialog: false,
      info: {
        nama: "",
        keterangan: "",
        tanggal_mulai: "",
        tanggal_selesai: ""
      },
      pengelola: [],
      defInfo: {
        nama: "",
        keterangan: "",
        tanggal_mulai: "",
        tanggal_selesai: ""
      }
    };
  },

  methods: {
    // eslint-disable-next-line
    open(obj) {
      this.info = obj ? obj : this.defInfo;
      this.dialog = true;
      let x = this.$refs.dlgKelasLuring.open();
      this.$validator.reset();
      return x;
    },
    toLink(val) {
      window.open(val.url_kelas, "_blank");
    },
  },

  computed: {
    isReady(){
      let now = new Date()
      let start =subDays(this.info.tanggal_mulai,2)
      return now>=start?true:false
    }
  }
};
</script>
